'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.filter('trimdecimals', function () {
    return function (num) {
        if (typeof num == 'string') {
            return num.replace(/(,|\.)00([^0-9]*)/, '$2');
        } else {
            return num;
        }
    };
}); // 10,00 => 10.00


//////////////////
// WEBPACK FOOTER
// ./src/core/trimdecimals.js
// module id = 53
// module chunks = 0 2